import React from 'react';

interface VeryLowProps {}

export function VeryLow(props: Readonly<VeryLowProps>) {
	return (
		<svg width={138} height={90} viewBox="0 0 138 90" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_20128)">
				<path
					fill="#7F7F7F"
					d="M36.421 54.33c.644 1.655 1.905 5.6-1.633 24.798-1.783 9.645-2.62 11.369-2.378 16.112a37.48 37.48 0 002.34 11.481c.206.696.478 1.308.697 1.889.218.581.25.855.338 1.299a15.246 15.246 0 01-12.13 17.799 15.495 15.495 0 01-7.095-.186 15.499 15.499 0 01-6.27-3.327 35.215 35.215 0 01-2.616-3.007 26.84 26.84 0 01-5.958-13.198c-.27-2.34-.223-4.706.139-7.033a55.583 55.583 0 012.063-7.09s1.067-3.682 1.692-7.25c.626-3.567.381-6.354-.802-14.245-1.699-11.277-2.24-13.133-2.4-15.071 0 0-.095-.835-.07-1.595-.039-4.854 2.895-10.845 3.19-11.46 2.278-4.565 3.15-4.45 5.452-9.46a18.105 18.105 0 001.896-5.468c.595-4.713-1.876-6.777-.714-8.639 1.45-2.325 6.85-1.784 10.277-.524 5.343 1.911 9.827 7.113 9.24 10.904a5.304 5.304 0 01-1.115 2.816c-1.113 1.302-2.495 1.246-3.208 2.615a3.624 3.624 0 00-.324 2.019c.193 2.338 2.083 3.08 4.365 5.922a36.65 36.65 0 015.024 9.899z"
				/>
				<path
					fill="#999"
					d="M40.365 15.685a38.25 38.25 0 01.155 6.961 39.48 39.48 0 01-.823 5.143 18.079 18.079 0 01-1.863 5.754 6.12 6.12 0 01-2.111 2.502 6.958 6.958 0 01-5.391.202 12.275 12.275 0 01-3.285-1.566c-1.466-.904-1.654-1.325-3.304-2.51a31.224 31.224 0 00-3.65-2.22c-3.228-1.736-3.37-1.203-4.994-2.278a12.663 12.663 0 01-4.544-5.612 17.266 17.266 0 01-.95-4.422 15.41 15.41 0 0130.746-1.965l.014.01zM26.725 96.635a7.045 7.045 0 01-9.715 2.239 7.351 7.351 0 01-2.766-3.117c-.176-.54-.41-1.288-.584-1.99a21.458 21.458 0 01-.639-4.222c-.137-2.867.401-3.947.373-6.453.05-3.152-.806-3.279-2.097-8.954a68.241 68.241 0 01-1.61-11.173c-.032-.926-.056-1.8-.094-2.59l-.014-.092c.005-1.121-.003-2.159.011-2.957a9.406 9.406 0 011.34-3.806 10.314 10.314 0 0114.263-3.224 10.675 10.675 0 014.58 5.744l.016.105c.135.897.26 1.715.475 2.52a.2.2 0 00.02.131c.495 3.212.535 6.476.118 9.699-.39 2.596-1.098 5.496-1.098 5.496-.62 2.415-.832 2.704-1.332 4.844-.562 2.05-.9 4.156-1.007 6.28a23.323 23.323 0 00.554 6.245 6.872 6.872 0 01-.794 5.275z"
				/>
				<path d="M44.125 14.596l71.046 13.746" stroke="#445662" strokeDasharray="1.5 2" />
				<path
					fill="#71828F"
					d="M40.853 69.08a.5.5 0 000 .707l3.182 3.182a.5.5 0 10.708-.707l-2.829-2.828 2.829-2.829a.5.5 0 00-.708-.707l-3.181 3.182zm74.572.707a.5.5 0 000-.707l-3.182-3.182a.5.5 0 10-.707.707l2.828 2.829-2.828 2.828a.5.5 0 00.707.707l3.182-3.182zm-74.218.147h73.864v-1H41.207v1z"
				/>
				<path d="M126.879 53.025l17.499 34.52" stroke="#505A63" strokeLinecap="round" />
				<path
					fill="#445662"
					d="M123.884 16.797l-4.799 56.284c2.745.04 5.113-1.975 5.336-4.589l.77-9.003.028-.002 3.176-37.585c.222-2.615-1.784-4.86-4.511-5.105z"
				/>
				<path
					fill="#71828F"
					d="M127.506 49.154l-1.373-.078-.865 9.893 1.228.07c.562.032 1.06-.37 1.11-.898l.828-7.974c.05-.528-.365-.981-.928-1.013z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2182_20128">
					<path fill="#fff" d="M0 0H138V90H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
